import React, { Component } from 'react';

import { withFirebase } from '../firebase';

class LogOut extends Component {

  componentDidMount() {
    let {firebase} = this.props
    firebase.auth.signOut().then(() => {
      this.props.history.replace('/login')
    }, function(error) {
      console.error('Sign Out Error', error);
    });
  };

  render() {
    return (
      <div>
        <h4>Logging out...</h4>
      </div>
    );
  }
}

export default withFirebase(LogOut);
